<script setup lang="ts"></script>

<template>
    <div class="flex justify-start items-center h-12 px-3">
        <span
            class="text-sm font-medium text-neutral-600 dark:text-neutral-400"
        >
            By
            <a
                href="https://s.naibuu.dev/me"
                class="text-neutral-700 underline dark:text-neutral-300"
                >Naibuu</a
            >.
        </span>
    </div>
</template>
